// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResultBox_wrapper__Auom6 {
  position: absolute;
  opacity: 0;
  bottom: -100px;
  right: 50%;
  transform: translate(50%, 0);
  background-color: #283b52;
  min-width: 600px;
  z-index: 401;
  overflow: auto;
  transition: 0.8s;
  min-height: 100px;
  padding: 10px 25px;
  border-radius: 10px;
  box-shadow: 0 1px 10px #2c3d52;
}

.ResultBox_show__C1p\\+7 {
  bottom: 30px;
  opacity: 1;
}

.ResultBox_optimeLogo__VawVo {
  height: 50px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ResultBox_close__U9WBE {
  position: absolute;
  top: 8px;
  left: 16px;
  width: 10px;
  height: 10px;
  color: white;
  transform: rotate(45deg);
  font-size: 1.3rem;
  cursor: pointer;
}

.ResultBox_optimeLogo__VawVo img {
  width: auto;
  height: 100%;
}

.ResultBox_Address__0\\+MZV {
  z-index: 2;
  padding: 10px 15px;
  text-align: right;
  font-size: 0.95rem;
  color: #e9e9e9;
  direction: rtl;
  display: flex;
  flex-direction: column;
}

.ResultBox_centerText__BkCUg {
  color: #2080b8;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 10px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ResultBox_editButton__TlfE4 {
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 10px;
  color: #e9e9e9;
}

.ResultBox_input__6s2aE {
  padding: 3px 8px;
  outline: none;
  font-size: 1rem;
  border-radius: 5px;
  color: #e9e9e9;
  background-color: transparent;
  width: 100%;
  border: 1px solid #e9e9e9;
  margin-bottom: 5px;
  direction: rtl;
}

.ResultBox_label__qU2nH {
  color: #e9e9e9;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  width: 150px;
  text-align: left;
}

.ResultBox_wrapperEditBox__DRZQm {
  display: flex;
  flex-direction: column;
  align-items: initial;
  justify-content: space-between;
  direction: ltr;
}

.ResultBox_line__GbgFr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ResultBox_setLocationButton__0qpdI {
  width: 300px;
  text-align: center;
  border: 1px solid #e9e9e9;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 15px;
  position: relative;
  bottom: 2px;
  padding: 3px 0;
}

.ResultBox_ltr__zEg-Q {
  direction: ltr !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ResultBox/ResultBox.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wrapper {\n  position: absolute;\n  opacity: 0;\n  bottom: -100px;\n  right: 50%;\n  transform: translate(50%, 0);\n  background-color: #283b52;\n  min-width: 600px;\n  z-index: 401;\n  overflow: auto;\n  transition: 0.8s;\n  min-height: 100px;\n  padding: 10px 25px;\n  border-radius: 10px;\n  box-shadow: 0 1px 10px #2c3d52;\n}\n\n.show {\n  bottom: 30px;\n  opacity: 1;\n}\n\n.optimeLogo {\n  height: 50px;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close {\n  position: absolute;\n  top: 8px;\n  left: 16px;\n  width: 10px;\n  height: 10px;\n  color: white;\n  transform: rotate(45deg);\n  font-size: 1.3rem;\n  cursor: pointer;\n}\n\n.optimeLogo img {\n  width: auto;\n  height: 100%;\n}\n\n.Address {\n  z-index: 2;\n  padding: 10px 15px;\n  text-align: right;\n  font-size: 0.95rem;\n  color: #e9e9e9;\n  direction: rtl;\n  display: flex;\n  flex-direction: column;\n}\n\n.centerText {\n  color: #2080b8;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 10px auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.editButton {\n  cursor: pointer;\n  position: absolute;\n  right: 15px;\n  top: 10px;\n  color: #e9e9e9;\n}\n\n.input {\n  padding: 3px 8px;\n  outline: none;\n  font-size: 1rem;\n  border-radius: 5px;\n  color: #e9e9e9;\n  background-color: transparent;\n  width: 100%;\n  border: 1px solid #e9e9e9;\n  margin-bottom: 5px;\n  direction: rtl;\n}\n\n.label {\n  color: #e9e9e9;\n  font-size: 0.8rem;\n  font-weight: 600;\n  white-space: nowrap;\n  width: 150px;\n  text-align: left;\n}\n\n.wrapperEditBox {\n  display: flex;\n  flex-direction: column;\n  align-items: unset;\n  justify-content: space-between;\n  direction: ltr;\n}\n\n.line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.setLocationButton {\n  width: 300px;\n  text-align: center;\n  border: 1px solid #e9e9e9;\n  cursor: pointer;\n  border-radius: 5px;\n  margin-left: 15px;\n  position: relative;\n  bottom: 2px;\n  padding: 3px 0;\n}\n\n.ltr {\n  direction: ltr !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ResultBox_wrapper__Auom6`,
	"show": `ResultBox_show__C1p+7`,
	"optimeLogo": `ResultBox_optimeLogo__VawVo`,
	"close": `ResultBox_close__U9WBE`,
	"Address": `ResultBox_Address__0+MZV`,
	"centerText": `ResultBox_centerText__BkCUg`,
	"editButton": `ResultBox_editButton__TlfE4`,
	"input": `ResultBox_input__6s2aE`,
	"label": `ResultBox_label__qU2nH`,
	"wrapperEditBox": `ResultBox_wrapperEditBox__DRZQm`,
	"line": `ResultBox_line__GbgFr`,
	"setLocationButton": `ResultBox_setLocationButton__0qpdI`,
	"ltr": `ResultBox_ltr__zEg-Q`
};
export default ___CSS_LOADER_EXPORT___;
